import EvaluatorItem from "./EvaluatorItem";

export default class TextMessageExportItem extends EvaluatorItem {
  static Currency() {
    return 'USD';
  }

  static CurrencySecondary() {
    return 'USD';
  }

  static DateFields = [
    'SassiePpacceptedOn',
    'TipaltiLastDataCheck',
    'EvBday',
    'EvLastShop',
    'EvInactive',
    'EvFraudGroupModifiedOn',
    'EvSignDate',
    'EvLastlogin',
  ];

  static BoolFields = [
    'Emailchanged',
    'EvInternational',
    'EvEmailoptout',
    'EvIsAgency',
    'EvVat',
    'EvVatexp',
    'EvPaymentOfficeOverride',
    'EvDdpverify',
    'TipaltiPayableStatus',
    'EvaluatorExtendedEvexVehicle',
  ];

  static FieldsToShowInDataTable() {
    return [
      { label: 'First Name', orderById: 'EvFirstName', data: 'EvFirstName', minWidth: '100px' },
      { label: 'Last Name', orderById: 'EvLastName', data: 'EvLastName', minWidth: '100px' },
      { label: 'Apollo Account Status', orderById: 'EvStatus', data: 'EvStatus', minWidth: '120px' },
      { label: 'Phone nr. 2', orderById: 'EvPhoneNumber2', data: 'EvPhoneNumber2OnlyNumbers', minWidth: '100px' },
      { label: 'Gender', orderById: 'EvaluatorExtendedEvexSex', data: 'EvaluatorExtendedEvexSex' },
      { label: 'Profile Language', orderById: 'ApolloLanguageName', data: 'ApolloLanguageName' },
    ];
  }
}
